import { useEffect, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import Field from '../components/Field.jsx'
import FormAlert from '../components/FormAlert.jsx'
import { api, ApiError } from '../lib/api.js'

export default function ResetPassword() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const token = params.get('token') || ''

  const [password, setPassword] = useState('')
  const [alert, setAlert] = useState(null)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    document.title = 'Choose a new password — Sonologue'
  }, [])

  async function onSubmit(event) {
    event.preventDefault()
    setBusy(true)
    setAlert(null)
    try {
      await api.confirmPasswordReset({ token, password })
      // Every other session was revoked with the reset, so there is nothing to
      // return to but the sign-in screen.
      navigate('/login', { replace: true, state: { reset: true } })
    } catch (error) {
      setAlert(error instanceof ApiError ? error.message : 'Something went wrong. Try again.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="auth-shell">
      <div className="card card-pad auth-card fade-up">
        <h1 className="auth-heading">Choose a new password</h1>
        {token ? (
          <>
            <p className="auth-sub">
              Setting a new password signs out every other device on your account.
            </p>
            <FormAlert>{alert}</FormAlert>
            {/*
              No `HiddenUsername` here, unlike the four password forms in
              Settings. This page knows the token and nothing else, and asking
              the API whose account it belongs to is the thing AGENTS.md
              forbids — "Login and password reset never reveal whether an
              account exists". A companion carrying a guessed or empty value
              would be worse than none: a password manager would save the new
              password under the wrong key. The credential saved with no
              username is offered for update at the next sign-in instead.
            */}
            <form onSubmit={onSubmit} noValidate>
              <Field
                label="New password"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                hint="At least 12 characters."
                autoComplete="new-password"
                required
              />
              <button type="submit" className="btn btn-primary btn-block" disabled={busy}>
                {busy ? 'Saving…' : 'Set password'}
              </button>
            </form>
          </>
        ) : (
          <p className="auth-sub">
            This link is missing its token. Ask for a new one from the sign-in screen.
          </p>
        )}
        <p className="auth-alt">
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  )
}
